var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05244 0.242668L6.84244 3.49267C6.94181 3.61563 7.00781 3.76212 7.03408 3.91801C7.06035 4.0739 7.04601 4.23393 6.99244 4.38267C6.9497 4.52146 6.86543 4.64381 6.75099 4.73321C6.63655 4.82262 6.49745 4.87478 6.35244 4.88267L0.752442 4.88267C0.597491 4.88577 0.445676 4.83878 0.319562 4.7487C0.193448 4.65862 0.0997668 4.53025 0.0524421 4.38267C-0.00112909 4.23393 -0.0154695 4.0739 0.0108043 3.91801C0.037078 3.76212 0.103079 3.61563 0.202442 3.49267L3.05244 0.242668C3.11126 0.165933 3.18696 0.103766 3.27366 0.0609814C3.36037 0.0181972 3.45576 -0.00405629 3.55244 -0.00405628C3.64913 -0.00405627 3.74452 0.0181972 3.83122 0.0609815C3.91793 0.103766 3.99362 0.165933 4.05244 0.242668Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpGray);
export default __webpack_public_path__ + "static/media/chevron-up-gray.fb7d71c5ee2089b2265f125870667484.svg";
export { ForwardRef as ReactComponent };